import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { accountType } from "../components/params";
import { AppIcons } from "../constants/app-icons";
// import store from "../store";
export default class ChartAccountService extends ApiService {
  namespace = "account";
  name = "Account";
  DOMAIN = 58;
  template = "defaultTemplate";
  icon = "BoxWithStar";
  favicon = "BoxWithStar";
  // Width = 700;
  action = "action";
  singular = this.terminology.account.singular;
  plural = this.terminology.account.plural;
  vowel = this.terminology.account.vowel;
  data = [];

  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.PROPERTY,
      field: "display_name",
    },
    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "number",
    },
    {
      header: this.t("type"),
      icon: AppIcons.NOTEBOOK,
      field: "type",
      template: (data) => {
        return this.parseType(data["type"]);
      },
    },
  ];
  gemItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.name }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "listing",
      services: -1,
      label: this.t("viewEntity", { entity: "Ledger" }),
      icon: AppIcons.BULLETS,
    },

    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.name }),
      icon: AppIcons.PLUS,
    },
    {
      key: "create",
      label: "Chart of Accounts",
      icon: AppIcons.SITEMAP,
      services: 59,
    },
  ];

  listMenuItems = [
    {
      key: "edit",
      label: "Open This Account",
      icon: AppIcons.BULLETS,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: -3,
      icon: AppIcons.BULLETS,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "listing",
      label: "View Ledger",
      icon: AppIcons.MAIL,
    },
    {
      key: "listing",
      label: "Transaction Report",
      icon: AppIcons.PRINTER,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
    {
      key: "delete",
      label: "deleteThisEntity",
      icon: AppIcons.CROSS,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.name }),
      icon: PrimeIcons.LIST,
    },
  ];
  filterItems = [
    { name: "Account Types", key: "account_type", value: "2", realm: "2" },
  ];

  getType() {
    accountType.forEach(() => {});
  }

  parseType(type) {
    let value = "";
    switch (type) {
      case 1:
        value = "Bank";
        break;
      case 2:
        value = "Account Receivable";
        break;
      case 3:
        value = "Current Asset";
        break;
      case 4:
        value = "Inventory";
        break;
      case 5:
        value = "Fixed Asset";
        break;
      case 6:
        value = "Other Asset";
        break;
      case 7:
        value = "Account Payable";
        break;
      case 8:
        value = "Current Liability";
        break;
      case 9:
        value = "Credit Card";
        break;
      case 10:
        value = "Other Liability";
        break;
      case 11:
        value = "Equity";
        break;
      case 12:
        value = "Revenue";
        break;
      case 13:
        value = "Cost of Sale";
        break;
      case 14:
        value = "Expense";
        break;
      case 15:
        value = "Other Income";
        break;
      case 16:
        value = "Other Expense";
        break;
      default:
        value = "Others";
        break;
    }
    return value;
  }
  constructor() {
    super("accounts");
  }

  filterAccounts(data, type) {
    var filterData = [];
    if (type) {
      filterData = data.filter(function (elem) {
        if (elem.type == type.type) return elem;
      });
    }

    return filterData;
  }
}
